import SmartHomeChallenge2026Modal from 'src/components/Modals/SmartHomeChallenge2026Modal.svelte';
import { PROMOTIONS } from 'src/constants';
import { profile_data } from 'src/stores/account/user';
import { get } from 'svelte/store';

export const SmartHomeChallenge2026ModalConfig = (forceShow = false) => {
	return {
		id: 'smartHomeChallenge2026',
		component: SmartHomeChallenge2026Modal,
		props: {
			showModal: true,
		},
		rules: [
			{
				check: () => {
					const now = new Date().getTime();
					const profileData = get(profile_data);
					const hasBeenSeen = !!profileData?.promotions?.smartHomeChallenge2026;

					return (
						now >= PROMOTIONS.SMART_HOME_CHALLENGE_2026.START_DATE &&
						now < PROMOTIONS.SMART_HOME_CHALLENGE_2026.END_DATE &&
						(!hasBeenSeen || forceShow)
					);
				},
				expected: true,
			},
		],
	};
};
